/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  position: relative;

  .nativo-tout--term-archive-1__image {
    width: 100%;
    height: auto;    
    object-fit: cover;
    color: transparent;
  }

  .ntvAdChoicesLink {
    display: none;
  }

 .nativo-tout--term-archive-1 .nativo-tout--term-archive-1__eyebrow {
    margin-bottom: 12px;
    font-size: 14px;
  }

  .nativo-tout--term-archive-1 .nativo-tout--term-archive-1__title {
    font-size: unset;
  }

  .ntv-headline {
    font-family: ${font.saolText};
    font-size: 18px;
    font-weight: 600;
    line-height: 120%; 
  }

  &.no-slider {
    display: flex;
    width: 100%;
    gap: 24px;
    .article-card {
      width: 33%;
      ul[class^='nativo-topic'] {
         width: 33%;
         .article-card {
           width: 100%;
           width: 100%;
         }
      }
    }
    &.full-width {
      .article-card {
        width: 25%;
      }
      ul[class^='nativo-topic'] {
         width: 25%;
         .article-card {
           width: 100%;
           width: 100%;
         }
      }
    }
  }

  .slick-slider {
    user-select: text;
  }

  .slick-slide {
    padding-right: 24px;
  }

  .slick-list {
    padding: 20px 0;
    
    @media (${breakpoint.mdMin}) {
      margin: 0 -16px;
      padding: 0 16px;
      overflow: hidden;
    }
  }
  @media (${breakpoint.mmMax}) {
    ul[class^='nativo-topic'] {
      min-width: 250px;
    }
  }

  .article-card {
    @media (${breakpoint.mmMax}) {
      min-width: 250px;
      img {
        min-width: 250px;
      }
    }
    .card-title {
      font-size: 18px;
    }
  }

  .slick-arrow:not(.next-shade):not(.prev-shade) {
    position: absolute;
    top: 100%;
    margin-top: 24px;

    span {
      border-color: ${getColor('iconPrimary')};
      display: block;
    }
    
    &.slick-disabled {
      cursor: initial;
      span {
        border-color: ${getColor('borderSecondary')};
      }
    }
  }
  .slick-prev:not(.next-shade):not(.prev-shade):hover, .slick-prev:not(.next-shade):not(.prev-shade):focus, 
  .slick-next:not(.next-shade):not(.prev-shade):hover, .slick-next:not(.next-shade):not(.prev-shade):focus {
    background-color: ${getColor('surfaceSecondary')};
  }

  .article-card {
    .card-title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
    }
  }

  @media (${breakpoint.mmMin}) {
    padding-bottom: 56px;
  }
  @media screen and (width: 512px) {
    padding-bottom: 0;
  }
`;
